import Button from "@restart/ui/esm/Button";
import React from "react";
import { Col, Form, Row } from "react-bootstrap";
import Navigation from "../../Home/Navigation/Navigation";
import bg from '../../Assets/bghero1.png';
import Footer from './../../Home/Footer/Footer';


const ContactMe = () => {
    return (
        <div className="herobg" style={{ background: `url(${bg})`, backgroundAttachment: "fixed", backgroundRepeat: "no-repeat", backgroundSize: "cover" }}>
            <Navigation />
            <hr className="text-center text-white w-75 mx-auto" />
            <h2 className="text-center text-info m-0 pt-3 txbg">Contact Me</h2>


            <Form action="https://formsubmit.co/knahar.kamrun@gmail.com" method="POST" style={{maxWidth: "600px", margin:"auto" }}>
            <Row className="mb-4">
              <Form.Group as={Col} controlId="formGridName">
                <Form.Label className="formText text-white">Name (Optional)</Form.Label>
                <Form.Control type ="text" name="name"  placeholder="Enter Your Name" />
              </Form.Group>
            </Row>
            <Row className="mb-4">
              <Form.Group as={Col} controlId="formGridEmail">
                <Form.Label className="formText text-white">Email</Form.Label>
                <Form.Control type ="email" name="email" required  placeholder="Enter Your Email" />
              </Form.Group>
            </Row>
            <Row className="mb-4">
              <Form.Group as={Col} controlId="formGridText">
                <Form.Label className="formText text-white">Text</Form.Label>
                <Form.Control type ="text" name="message" required  placeholder="Enter Your Message" />
              </Form.Group>
                </Row>
                <div className="text-center mt-5">
                 <Button  className="btnDetails w-20" type ="submit">Send</Button>
                 </div>
            </Form>
            <Footer />
            </div >
    );
};

export default ContactMe;